import type { FeedbackMessages } from './en';

const ms: FeedbackMessages = {
  qualified: {
    title: 'Terima kasih kerana melengkapkan kajian ini!',
    text: 'Anda boleh menutup tetingkap pelayar ini sekarang.\n\nKami berharap dapat bertemu anda lagi tidak lama lagi.',
  },
  quotaFull: {
    title: 'Kajian ini telah ditutup',
    text: 'Terima kasih atas minat anda terhadap kajian kami.\n\nMalangnya kami telah menerima semua maklum balas yang diperlukan.\n\nKami berharap dapat bertemu anda dalam salah satu kajian kami pada masa hadapan!',
  },
  terminated: {
    title: 'Terima kasih atas maklum balas anda!',
    text: 'Kami berharap dapat bertemu anda lagi dalam kajian kami pada masa hadapan. Sementara itu, kami mengucapkan semoga hari anda menyenangkan.\n\nSila tutup tetingkap pelayar ini.',
  },
  mismatch: {
    title: 'Terima kasih atas minat anda',
    text: 'Malangnya, anda tidak termasuk dalam kumpulan sasaran bagi kajian khusus ini.\n\nAnda boleh menutup halaman ini.',
  },
  error: {
    title: 'Kami tidak dapat memproses permintaan anda',
    linkProblemDetailed:
      'Pautan yang anda ikuti mengalami masalah. Sila semak sama ada pautan pada bar alamat sepadan dengan yang diberikan kepada anda, dan cuba lagi.',
    linkProblemGeneric: 'Pautan yang anda ikuti mengalami masalah. Sila cuba lagi.',
    contactPerson:
      'Jika masalah ini berterusan, sila maklumkan perkara ini kepada orang yang memberikan pautan tersebut kepada anda.',
  },
};

export default ms;
